export const SOFTWARE_POSS_QUERY_KEY = 'softwarePOSsQueryKey'
export const ACCOUNT_SOFTWARE_POSS_QUERY_KEY = 'accountSoftwarePOSsQueryKey'
export const SOFTWARE_POSS_SHIFT_QUERY_KEY = 'softwarePOSsShiftQueryKey'
export const RECEIPT_QUERY_KEY = 'receiptQueryKey'
